import { render, staticRenderFns } from "./bonusPayment.vue?vue&type=template&id=55e582e5&scoped=true"
import script from "./bonusPayment.vue?vue&type=script&lang=js"
export * from "./bonusPayment.vue?vue&type=script&lang=js"
import style0 from "./bonusPayment.vue?vue&type=style&index=0&id=55e582e5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e582e5",
  null
  
)

export default component.exports